const State = {
    documents:[],
}

export default State;